module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changeAttribution":"Change Attribution","required":"@:labels.required","save":"@:labels.save"},"fr":{"changeAttribution":"Changer l\u0027attribution","required":"@:labels.required","save":"@:labels.save"}}')
  delete Component.options._Ctor
}
